export default class AdfAnimations
{

// Works in tandem with Animate.css => https://animate.style/
    constructor ( props )
    {

        this.toAnimate = document.querySelectorAll( '.animate-me' );

        // nothing to animate
        if ( !this.toAnimate )
        {
            return;
        }

        this.setupIntersectionObserver();
    }

    setupIntersectionObserver ()
    {

        this.intersectionObserver = new IntersectionObserver( ( entries, observer ) =>
        {

            entries.forEach( ( entry ) =>
            {
                // console.log( entry.target, entry.intersectionRatio )
                if ( entry.isIntersecting )
                {

                    let animationData = entry.target.dataset.animation;
                    // console.log( 'animationData', animationData, typeof animationData );
                    if ( !animationData )
                    {
                        return;
                    }

                    let animationsExploded = animationData.split( ' ' );
                    animationsExploded     = animationsExploded.map( e => 'animate__' + e );
                    // console.log( 'animationsExploded', animationsExploded, typeof animationsExploded, Array.isArray( animationsExploded ) );


                    animationsExploded.forEach( e => entry.target.classList.add( e ) );
                    entry.target.classList.add( 'animate__animated' );
                    entry.target.classList.remove( 'animate-me' );

                    this.intersectionObserver.unobserve( entry.target );

                } else
                {
                    // entry.target.classList.remove( 'animate__animated' );
                }
            } )
        }, {

            threshold : 0.1,
        } );


        Array.from( this.toAnimate ).forEach( el => this.intersectionObserver.observe( el ) );


    }

}
